
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../Home/AppHome.css";
import '../Admin/Admin.css';
import Header2 from "./Header2";

export default function NewMemberHome() {
  const navigate = useNavigate();

       useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  return (
    <div className="dashboard">

      <Header2 />

      <div className="welcome-container">


        <div className="button-container">
          <button className="big-btn" onClick={() => navigate("/assis/attendance_KB")}>
            👥 Mark Attendance [Kesbawe]
          </button>

          <button className="big-btn blue" onClick={() => navigate("/assis/attendance_WB")}>
             👥 Mark Attendance [Werahare]
          </button>


        </div>
      </div>
    </div>
  );
}
